import api from '@/utils/api';

/**
 * Get a Company Template
 * @param {string} companyId - Query to filter companies
 * @param {string} templateId - The template id
 * @returns {Promise}
 */
const getCompanyTemplateApi = (companyId, templateId) =>
  api.get(`company/${companyId}/template/${templateId}`);

export default getCompanyTemplateApi;
